import React, { useEffect, useState } from "react"
import MainContainer from "../../components/MainContainer"
import MainHeader from "../../components/MainHeader"
import Title from "../../components/Title"
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper"
import AddIcon from "@mui/icons-material/Add"

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline"
import EditDocumentIcon from "@mui/icons-material/EditNote"

import { useHistory } from "react-router-dom"

import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Card from "@mui/material/Card"
import Grid2 from "@mui/material/Grid2"
import IconButton from "@mui/material/IconButton"
import Typography from "@mui/material/Typography"

import { toast } from "react-toastify"
import api from "../../services/api"

import ModalConfirm from "../../components/ModalConfirm"
import ContextMenu from "../../components/ContextMenu"
import ModalShare from "./ModalShare"

import SendIcon from "@mui/icons-material/Send"

function Forms() {
    const history = useHistory()

    const [openModalShare, setOpenModalShare] = useState(false)
    const [selectedUUID, setSelectedUUID] = useState("")

    const [loading, setLoading] = useState(false)
    const [forms, setForms] = useState([])
    const [openModalDelete, setOpenModalDelete] = useState(false)

    const [selectedForm, setSelectedForm] = useState(null)

    async function getForms() {
        try {
            const res = await api.get("/forms")
            setForms(res.data)
        } catch (error) {
            toast.error("Erro ao buscar formulários")
        }
    }

    useEffect(() => {
        getForms()
    }, [])

    const handleNewForm = () => {
        history.push("/form")
    }

    const handleNavigateEditForm = (id) => {
        history.push(`/form/${id}`)
    }

    const handleCloseModalDelete = () => {
        setOpenModalDelete(false)
        setSelectedForm(null)
    }

    const handleDeleteForm = async () => {
        try {
            setLoading(true)

            await api.delete(`/forms/${selectedForm}`)

            setForms(forms.filter((form) => form.id !== selectedForm))

            handleCloseModalDelete()

            setLoading(false)
        } catch (error) {
            setLoading(false)
            toast.error("Erro ao excluir formulário")
        }
    }

    const handleView = (uuid) => {
        const el = document.createElement("a")
        el.href = `/form-preview/${uuid}`
        el.target = "_blank"
        document.body.appendChild(el)

        el.click()

        document.body.removeChild(el)
    }

    return (
        <MainContainer>
            <ModalConfirm
                open={openModalDelete}
                title="Excluir formulário?"
                description="Esta ação não pode ser desfeita"
                onApprove={handleDeleteForm}
                onCancel={handleCloseModalDelete}
            />

            <ModalShare
                open={openModalShare}
                onClose={() => {
                    setSelectedUUID("")
                    setOpenModalShare(false)
                }}
                uuid={selectedUUID}
            />

            <MainHeader>
                <Title>Formulários</Title>
                <MainHeaderButtonsWrapper>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleNewForm}
                        startIcon={<AddIcon />}
                        loading={loading}
                    >
                        Novo formulário
                    </Button>
                </MainHeaderButtonsWrapper>
            </MainHeader>

            <Grid2 container spacing={2} sx={{ mt: 2 }}>
                {forms.map((form) => (
                    <Grid2
                        key={form.id}
                        size={{
                            xs: 12,
                            md: 6,
                            lg: 4,
                            xl: 3,
                        }}
                    >
                        <Card
                            variant="outlined"
                            sx={{
                                p: 1,
                            }}
                        >
                            <Box
                                style={{
                                    position: "relative",
                                }}
                            >
                                <Typography variant="h6">
                                    {form.title || "(Sem título)"}
                                </Typography>

                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: 0,
                                        right: 0,
                                    }}
                                >
                                    <ContextMenu
                                        options={[
                                            form.status === "active" && {
                                                label: "Enviar",
                                                handler: () => {
                                                    setSelectedUUID(form.uuid)
                                                    setOpenModalShare(true)
                                                },
                                            },
                                            {
                                                label: "Editar",
                                                handler: () =>
                                                    handleNavigateEditForm(
                                                        form.id,
                                                    ),
                                            },
                                            {
                                                label: "Visualizar",
                                                handler: () =>
                                                    handleView(form.uuid),
                                            },
                                            {
                                                label: "Excluir",
                                                handler: () => {
                                                    setSelectedForm(form.id)
                                                    setOpenModalDelete(true)
                                                },
                                            },
                                        ]}
                                    />
                                </Box>
                            </Box>

                            <Typography variant="subtitle2">
                                {form.description}
                            </Typography>

                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                mt={2}
                            >
                                {form.status === "active" && (
                                    <Box
                                        display="flex"
                                        alignItems="center"
                                        gap={1}
                                    >
                                        <CheckCircleOutlineIcon color="success" />
                                        <Typography
                                            variant="caption"
                                            color="success"
                                        >
                                            Ativo
                                        </Typography>
                                    </Box>
                                )}

                                <Box display="flex" alignItems="center" gap={1}>
                                    {form.status === "draft" && (
                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            gap={1}
                                        >
                                            <EditDocumentIcon />
                                            <Typography variant="caption">
                                                Rascunho
                                            </Typography>
                                        </Box>
                                    )}

                                    <Typography variant="caption">
                                        {form.questions.length
                                            ? `${form.questions.length} perguntas`
                                            : "Nenhuma pergunta"}
                                    </Typography>
                                    {form.status === "active" && (
                                        <IconButton
                                            onClick={() => {
                                                setSelectedUUID(form.uuid)
                                                setOpenModalShare(true)
                                            }}
                                            size="small"
                                        >
                                            <SendIcon
                                                width={8}
                                                sx={{
                                                    transform: "rotate(-30deg)",
                                                }}
                                            />
                                        </IconButton>
                                    )}
                                </Box>
                            </Box>
                        </Card>
                    </Grid2>
                ))}
            </Grid2>
        </MainContainer>
    )
}

export default Forms
